import {FormControl, AbstractControl, ValidatorFn} from '@angular/forms';
import {isNullOrUndefined} from 'util';

export class GlobalValidator {

  static mailFormatValidator(c: FormControl): ValidationResult {

    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (!isNullOrUndefined(c.value) && c.value !== '' && (c.value.lenght <= 5 || !EMAIL_REGEXP.test(c.value))) {
      return {'incorrectMailFormat': true};
    }
    return null;
  }

  static validIdValidator(c: FormControl): ValidationResult {
    const ID_REGEXP = /^[a-z0-9_]+$/i;
    if (c.value !== '' && !ID_REGEXP.test(c.value)) {
      return {'incorrectIdFormat': true};
    }
    return null;
  }

  static intValueValidator(c: FormControl): ValidationResult {
    const number = Number(c.value);
    return (!isNaN(number) && Math.floor(number) === number) ? null : {'nonInteger': true};
  }

  static minValueValidator(minValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      // console.log(`Control:${JSON.stringify(control)}`);
      const number = Number(control.value);
      return (isNaN(number) || number < minValue) ? {'minValue': true} : null;
    };
  }

  static maxValueValidator(maxValue: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      // console.log(`Control:${JSON.stringify(control)}`);
      const num = Number(control.value);
      return (isNaN(num) || num > maxValue) ? {'maxValue': true} : null;
    };
  }

  static complexityValidator(minSize: number, needNumber: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const srt: string = control.value;
      const result = {};
      if (srt.length === 0) {
        return result;
      }
      if (srt.length < minSize) {
        result['LengthTooSmall'] = true;
      }
      if (!/^(?=.*[a-zA-Z])(?=.*[0-9])/i.test(srt)) {
        result['NeedNumbersAndLetters'] = true
      }
      return result;
    };
  }

  static matchPasswordValidator(ac: AbstractControl) {
    const password = ac.get('password').value;
    const passwordConfirmation = ac.get('passwordConfirmation').value;
    if (password !== passwordConfirmation) {
      ac.get('passwordConfirmation').setErrors({MatchPassword: true});
    } else {
      return null;
    }
  }
}

interface ValidationResult {
  [key: string]: boolean;
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/global-validator.ts